export default __webpack_public_path__ + "static/media/icon4.1271b2d9.png";